import { render, staticRenderFns } from "./SuperAdminCourseApplications.vue?vue&type=template&id=54f859b2&scoped=true"
import script from "./SuperAdminCourseApplications.vue?vue&type=script&lang=js"
export * from "./SuperAdminCourseApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f859b2",
  null
  
)

export default component.exports